import { Injectable } from "@angular/core";
import { IndividualConfig, ToastrService } from "ngx-toastr";
import { TranslateService } from "@ngx-translate/core";

@Injectable({ providedIn: "root" })
export class ToasterService {
  constructor(
    private toastr: ToastrService,
    private translate: TranslateService
  ) { }

  public showSuccess(title: string, message: string, config?: Partial<IndividualConfig>) {
    this.toastr.success(message, title, config);
  }

  public showError(title: string, message: string, config?: Partial<IndividualConfig>) {
    this.toastr.error(message, title, config);
  }

  public showWarning(title: string, message: string, config?: Partial<IndividualConfig>) {
    this.toastr.warning(message, title, config);
  }

  public showInfo(title: string, message: string, config?: Partial<IndividualConfig>) {
    this.toastr.info(message, title, config);
  }

  /**
   * Displays a message indicating success, with a generic title.
   * @param message The message to be displayed.
   */
  public success(message: string, config?: Partial<IndividualConfig>) {
    const title = this.translate.instant("MESSAGES.SUCCESS");
    this.toastr.success(message, title, config);
  }

  /**
   * Displays a message indicating an error, with a generic title.
   * @param message The message to be displayed.
   */
  public error(message: string, config?: Partial<IndividualConfig>) {
    const title = this.translate.instant("MESSAGES.ERROR");
    this.toastr.error(message, title, config);
  }

  /**
   * Displays a message indicating a warning, with a generic title.
   * @param message The message to be displayed.
   */
  public warning(message: string, config?: Partial<IndividualConfig>) {
    const title = this.translate.instant("MESSAGES.WARNING");
    this.toastr.warning(message, title, config);
  }

  /**
   * Displays an informational message, with a generic title.
   * @param message The message to be displayed.
   */
  public info(message: string, config?: Partial<IndividualConfig>) {
    const title = this.translate.instant("MESSAGES.INFO");
    this.toastr.info(message, title, config);
  }
}
